<template>
    <input
        type="text"
        class="bg-yellow py-2 px-3 uppercase text-dark rounded text-2xl text-center placeholder:text-dark font-bold h-10"
        maxlength="8"
        :value="modelValue"
        @change="$emit('update:modelValue', $event.target.value)"
        placeholder="your reg"
    >
</template>

<script>
export default {
    props: {
        modelValue: String
    }
}
</script>

<style scoped>

</style>
